import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { userGradeType } from '../../../../utils/auth';
import MoreButton from '../../../components/moreButton/MoreButton';
import { useReportContext } from '../../../../context/DetailContext';
import LimitTable from '../../../components/limit/DetailLimitTable';
interface DataProps {
  rank: number;
  content: string;
  check: string;
}
interface CheckListProps {
  data: DataProps[];
}

const CheckList = ({ data }: CheckListProps) => {
  const { regionAccess, quotaAccess } = useReportContext();
  const [showMore, setShowMore] = useState(false);

  return (
    <Container id="권리분석">
      <Title>
        <span>권리분석 체크 리스트</span>
      </Title>

      {!regionAccess || !quotaAccess ? (
        <LimitTable title="권리분석 체크 리스트는" />
      ) : (
        <Content>
          <table
            style={{
              borderCollapse: 'collapse',
              borderSpacing: '0px',
              width: '100%',
              borderTop: '1px solid #E5E8EA',
            }}
          >
            <thead>
              <tr
                style={{
                  width: '100%',
                  // borderCollapse: 'separate',
                }}
              >
                <TableHeadTh width={'20%'}>순위</TableHeadTh>
                <TableHeadTh width={'60%'}>종류</TableHeadTh>
                <TableHeadTh width={'20%'}>유무</TableHeadTh>
              </tr>
            </thead>
            <tbody>
              {data.slice(0, showMore ? data.length : 3).map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: item.check === '있음' ? '#E6F3FF' : '#fff',
                    borderBottom: '1px solid #e1e2e4',
                  }}
                >
                  <TablebodyTd
                    width={'20%'}
                    isCheck={item.check === '있음' ? true : false}
                  >
                    {item.rank}
                  </TablebodyTd>
                  <TablebodyTd
                    width={'60%'}
                    isCheck={item.check === '있음' ? true : false}
                  >
                    {item.content}
                  </TablebodyTd>
                  <TablebodyTd
                    width={'20%'}
                    isCheck={item.check === '있음' ? true : false}
                  >
                    {item.check}
                  </TablebodyTd>
                </tr>
              ))}
            </tbody>
          </table>
          {data.length > 3 && (
            <MoreButton
              name="권리분석 체크 리스트"
              showAll={showMore}
              setShowAll={setShowMore}
              sectionId="권리분석"
            />
          )}
        </Content>
      )}
    </Container>
  );
};

export default CheckList;

interface WidthProps {
  width: string;
  isCheck?: boolean;
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: #fff;
  padding: 24px 16px;
`;

const Title = styled.div`
  width: 100%;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26.1px;
  letter-spacing: -0.44px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: flex-end;
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const TableHeadTh = styled.th<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;
  padding: 10px 12px;
  background-color: #f7f8fc;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 18.85px; /* 26.1px */
  letter-spacing: -0.36px;
  color: #616161;

  border-right: 1px solid #e8e9ea;
  &:last-child {
    border-right: none;
  }
`;
const TablebodyTd = styled.td<WidthProps>`
  width: ${({ width }) => width};
  text-align: center;

  padding: 10px 12px;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20.3px;
  letter-spacing: -0.32px;
  color: ${({ isCheck }) => (isCheck ? '#008AFF' : '#171e26')};

  border-right: 1px solid #e8e9ea;
  &:last-child {
    border-right: none;
  }
`;
